/**
 * 独自エラーを作成する際に継承しなければいけない抽象クラス。
 */
export default abstract class RedsealError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}